import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../dto/dto.js';
import { LocalizedPhotoReference } from './localized-photo-reference.js';

export class LocalizedPhotoCollection extends DataModel {
  static readonly TYPE_ID: string = 'bb9a29b2de344c508a52f8dabd0c978d';

  constructor(
    public readonly storagePath: string,
    public readonly uploadKey: string,
    public readonly photos: LocalizedPhotoReference[],
  ) {
    super();
  }

  get $typeId() {
    return LocalizedPhotoCollection.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocalizedPhotoCollection {
    return new LocalizedPhotoCollection(
        MapUtils.get<string>(map, 'storagePath'),
        MapUtils.get<string>(map, 'uploadKey'),
        MapUtils.getList<LocalizedPhotoReference>(
            map,
            'photos',
            (value: unknown) => context.fromData<LocalizedPhotoReference>(value as SerializedData),
        ),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'storagePath': this.storagePath,
      'uploadKey': this.uploadKey,
      'photos': this.photos.map((p) => context.toData<LocalizedPhotoReference>(p)),
    };
  }

  clone(): this {
    return new LocalizedPhotoCollection(
        this.storagePath,
        this.uploadKey,
        this.photos.map((e) => e.clone()),
    ) as this;
  }

  isSame(other: LocalizedPhotoCollection): boolean {
    if(other === this) {
      return true;
    }

    return other.storagePath === this.storagePath &&
      other.uploadKey === this.uploadKey &&
      isSameList(other.photos, this.photos, isSameData);
  }
}

export class LocalizedPhotoCollectionBuilder extends DataModelBuilder<LocalizedPhotoCollection> {
  build(context: SerializationContext, map: SerializedData): LocalizedPhotoCollection {
    return LocalizedPhotoCollection.fromMap(context, map);
  }
}
